import { Input } from '@alifd/next';
import wrapper from './next-wrapper';
const FormPassword = wrapper(Input.Password, 'CbayelFormPassword');
export default FormPassword;
